<template>
    <div class="top-dashboard">
        <nav class="top-dashboard__mobile-menu-container" role="navigation">
            <v-container class="menu-toggle">
                <v-layout>
                    <v-icon color="#000" large dark @click.stop="drawer = !drawer">menu</v-icon>
                </v-layout>
            </v-container>

            <v-navigation-drawer dark temporary v-model="drawer" width="210" fixed>
                <v-list>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="top-nav__item custom-title-font">
                                <router-link to="/">Sākums</router-link>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="top-nav__item custom-title-font">
                                <router-link to="/zinas">Ziņas</router-link>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="top-nav__item custom-title-font">
                                <router-link to="/ParMums">Par mums</router-link>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="top-nav__item custom-title-font">
                                <router-link to="/Svetki">Ēdiena svētki</router-link>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="top-nav__item custom-title-font">
                                <router-link to="/veikals">Veikals</router-link>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <div class="top-nav__item top-nav__support-us-btn-mobile custom-title-font">
                                <v-btn ripple light to="/atbalstit"><i class="fas fa-heart"></i> Atbalstīt</v-btn>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </nav>
        <div class="top-dashboard__logo-container">
            <router-link to="/"><img class="top-dashboard__logo" src="@/assets/img/logo.png" alt="logo"/></router-link>
        </div>
        <ul class="top-nav">
            <li class="top-nav__item custom-title-font"><router-link to="/">Sākums</router-link></li>
            <li class="top-nav__item custom-title-font"><router-link to="/zinas">Ziņas</router-link></li>
            <li class="top-nav__item custom-title-font"><router-link to="/parmums">Par mums</router-link></li>
            <li class="top-nav__item custom-title-font"><router-link to="/svetki">Ēdiena svētki</router-link></li>
            <li class="top-nav__item custom-title-font"><router-link to="/veikals">Veikals</router-link></li>
        </ul>

        <div class="header__social-icons">
            <ShoppingCart class="top-nav__shopping-cart"></ShoppingCart>
            <div v-if="authorized" class="top-nav__profile">
                <router-link to="/pieslegties">
                    <v-avatar size="25" color="#000">
                        <v-icon dark>account_circle</v-icon>
                    </v-avatar>
                </router-link>
            </div>
            <div class="social-icons__item">
                <a target="_blank" href=https://www.facebook.com/augamlv><i class="fab fa-facebook"></i></a>
            </div>
            <div class="social-icons__item">
                <a target="_blank" href=https://www.instagram.com/augamlv/><i class="fab fa-instagram"></i></a>
            </div>
            <div class="top-nav__item top-nav__support-us-btn custom-title-font">
                <v-btn ripple dark to="/atbalstit"><i class="fas fa-heart"></i> Atbalstīt</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import firebase from 'firebase/app'
    import ShoppingCart from './shop/ShoppingCart.vue'

    document.addEventListener("scroll", () => {
        let pageTop = window.pageYOffset;
        const topDash = document.querySelector(".top-dashboard");
        if(pageTop > 50){
            topDash.classList.add("top-moved");
        } else {
            topDash.classList.remove("top-moved");
        }
    });

    export default {
        name: "TopDash",
        components: {
            ShoppingCart
        },
        data() {
            return {
                drawer: null,
                authorized: false
            }
        },
        mounted() {
            const that = this;

            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    that.authorized = true;
                } else {
                    that.authorized = false;
                }
            });
        }
    }
</script>

<style>
    .top-nav__shopping-cart {
        position: fixed;
        top: 55px;
        right: 20px;
    }
    .top-nav__profile {
        margin: 5px 10px;
        font-size: 30px;
        color: #000;
        display: flex;
        align-items: center;
    }
    .top-nav__profile a {
        display: flex;
        justify-content: center;
        overflow: hidden;
    }
    .social-icons__item{
        margin: 5px 10px;
        font-size: 30px;
        color: #000;
        display: inline-block;
    }
    .social-icons__item a{
        text-decoration: none;
        color: inherit;
    }
    .social-icons__item:hover{
        color: #79C616;
        transition: 0.5s;
    }
    .header__social-icons{
        margin: 0 25px;
        position: absolute;
        right: 15px;
        display: flex;
    }
    .top-nav__support-us-btn {
        align-self: center;
        justify-self: center;
        font-size: 20px;
    }
    .top-nav__support-us-btn .v-btn {
        height: 28px;
    }
    .top-nav__support-us-btn-mobile .v-btn {
        height: 28px;
    }
    .top-nav__support-us-btn-mobile {
        justify-self: center;
        font-size: 20px;
        margin-top: 18px;
    }
    .top-nav__support-us-btn .fa-heart {
        color: red;
        margin-right: 5px;
    }
    .top-nav__support-us-btn-mobile .fa-heart {
        color: red;
        margin-right: 5px;
    }

    .top-dashboard{
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        z-index: 1000;
        transition: background-color 0.3s ease;
    }
    .top-dashboard__mobile-menu-container {
        position: absolute;
        left: 0;
    }
    .top-dashboard__logo-container{
        margin: 0 25px;
        position: absolute;
        left: 15px;
        top: 0;
    }
    .top-dashboard__logo{
        height: 100px;
        transition: height 0.3s ease;
    }
    .top-moved{
        background-color: #fff;
        /*border-bottom: 3px solid #A9D969;*/
    }
    .top-moved .top-dashboard__logo{
        height: 50px;
    }
    .top-nav{
        text-decoration: none;
        list-style-type: none;
        padding: 0;
        margin: 0 25px;
        text-align: center;
        font-size: 22px;
        color: #ffffff;
        text-shadow: 1px 1px 0px #404040, 0 0 4px #404040;
    }
    .top-nav li{
        display: inline-block;
    }
    .top-nav__item a{
        padding: 0 15px;
        cursor: pointer;
        position: relative;
        color: inherit;
        text-decoration: none;
        outline: 0;
    }
    .top-nav__item a{
        text-decoration: none;
    }
    .top-nav .top-nav__item a:before{
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: -5px;
        left: 0;
        background-color: #000;
        visibility: hidden;
        transform: scaleX(0);
    }
    .top-nav__item a:hover:before{
        visibility: visible;
        transform: scaleX(1);
        transition: all 0.3s ease-in-out 0s;
    }
    .top-nav__item .router-link-exact-active {
        color: #BBDB9B;
    }
    .top-moved .top-nav{
        color: #404040;
        text-shadow: 1px 1px 1px #888;
    }

    .menu-toggle { display: none; }
    @media (max-width: 1140px) {
        .top-nav { visibility: hidden; }
        .top-nav__support-us-btn { display: none; }
        .top-dashboard__logo-container { margin: 0 auto; left: unset; }
        .menu-toggle { display: block; }
    }
</style>